module.exports = __webpack_public_path__ + "img/wechat_pay.b8a93b3b.png";